import { Injectable } from "@angular/core";
import download from "downloadjs";
import browser from "browser-detect";
import * as pdfjsLib from "pdfjs-dist";
// update version when pdfjs-dist updates
// https://stackoverflow.com/a/63406257
pdfjsLib.GlobalWorkerOptions.workerSrc = "https://npmcdn.com/pdfjs-dist@2.10.377/build/pdf.worker.js";
import debounce from "lodash/debounce";
import { from } from "rxjs";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class PrintPdfService {
  private browser = browser();
  private renderedPdf: any = null;
  private canvas: any = [];
  private wndw: any = null;

  constructor(private toastr: ToastrService) {}

  private reset() {
    this.canvas = [];
    this.renderedPdf = null;
  }

  private renderPage(pageSize, pageNumber, title) {
    const printDebounce = debounce(() => this.printCanvas(title), 50);

    this.renderedPdf.getPage(pageNumber).then((page: any) => {
      console.log("Page loaded", pageNumber);

      const scale = 5;
      const viewport = page.getViewport({ scale: scale });

      let canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render PDF page into canvas context
      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };
      let renderTask: any = page.render(renderContext);

      from(renderTask.promise).subscribe((d) => {
        this.canvas = this.canvas.concat([canvas.toDataURL()]);
        if (pageSize == pageNumber) {
          printDebounce();
        }
      });
    });
  }

  printCanvas(title: string) {
    let imgs: string = "";
    for (const imagePath of this.canvas) {
      imgs += `<img src="${imagePath}">`;
    }
    const size = "A4";
    const windowContent = `
      <!DOCTYPE html>
      <html moznomarginboxes mozdisallowselectionprint>
        <head>
          <title>${title}</title>
          <style type="text/css" media="print">
            @page
            { size: ${size}; margin: 0; }
            html{ padding: 0;margin: 0; }
            body { padding: 0; margin: 0; width: auto; height: auto; overflow:  visible; }
            img{ width: 100%; }
            @media print {
              html, img {
                padding: 0;
                margin: 0;
              }
              body {
                padding: 0;
                margin: 0;
                width: auto;
                height: auto;
                overflow: visible;
              }
              img{ width: 100%; }
            }
          </style>
        </head>
        <body class="${size}">${imgs}</body>
      </html>
    `;
    const btype = this.browser.name;
    const wSize = {
      moz: { width: 490, height: 340 },
      others: { width: 900, height: 570 },
    };
    const width = btype == "firefox" ? wSize.moz.width : wSize.others.width;
    const height = btype == "firefox" ? wSize.moz.height : wSize.others.height;
    const y = window.outerHeight / 2 + window.screenY - height / 2;
    const x = window.outerWidth / 2 + window.screenX - width / 2;
    const windowProps = `width=${
      btype == "firefox" ? wSize.moz.width : wSize.others.width
    },height=${
      btype == "firefox" ? wSize.moz.height : wSize.others.height
    },toolbar=no,location=no,directories=no,status=no,menubar=no,resizable=no,top=${y},left=${x}`;
    const printWin = window.open("", "print", windowProps);
    let printStarted = false;

    if (!printWin) {
      this.toastr.error(
        "Failed to open a print popup. This could be due to a browser extension/add-on. Please disable them to proceed."
      );
      return;
    }

    printWin.document.open();
    printWin.document.write(windowContent);
    printWin.document.close();
    printWin.onload = () => {
      printWin.focus();
      printWin.print();
      printWin.close();
    };
    printWin.addEventListener("beforeprint", () => (printStarted = true));
    printWin.onbeforeunload = () => {
      /** chrome check. does not work on firefox */
      if (printStarted === false) {
        this.toastr.error(
          "Failed to open a print popup. This could be due to a browser extension/add-on. Please disable them to proceed."
        );
      }
    };
  }

  public startPrint(url, title) {
    this.reset();
    const loadingTask: any = pdfjsLib.getDocument(url);
    from(loadingTask.promise).subscribe((pdf: any) => {
      this.renderedPdf = pdf;
      for (let p = 1; p <= pdf.numPages; p++) {
        this.renderPage(pdf.numPages, p, title);
      }
    });
  }

  public startDownload(url: string, fileType: string, fileName?: string) {
    let x = new XMLHttpRequest();
    x.open("GET", url, true);
    x.responseType = "blob";
    x.onload = function (e: any) {
      download(e.target.response, fileName, fileType);
    };
    x.send();
  }
}
